import React from 'react';
import { motion } from 'framer-motion';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  .irs-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .irs-page { font-family: 'Inter', sans-serif; color: #0f172a; background: #ffffff; width: 100%; }

  /* ─── Hero ─────────────────────────────────────────────────── */
  .irs-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .irs-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 520px; height: 520px; border-radius: 50%; background: radial-gradient(circle, rgba(245,158,11,0.14), rgba(217,119,6,0.06)); filter: blur(80px); pointer-events: none; }
  .irs-hero-blob2 { position: absolute; bottom: -12%; left: -8%; width: 560px; height: 560px; border-radius: 50%; background: radial-gradient(circle, rgba(239,68,68,0.08), rgba(220,38,38,0.04)); filter: blur(90px); pointer-events: none; }
  .irs-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .irs-hero-inner { grid-template-columns: 1fr; } .irs-hero-visual { display: none; } }
  .irs-back-btn { display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px; border-radius: 999px; border: 1px solid #e2e8f0; background: #fff; color: #475569; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.18s ease; margin-bottom: 24px; }
  .irs-back-btn:hover { background: #fff7ed; border-color: #fcd34d; color: #d97706; }
  .irs-hero-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #fff7ed; border: 1px solid #fed7aa; font-size: 13px; font-weight: 500; color: #92400e; margin-bottom: 28px; }
  .irs-badge-dot { width: 7px; height: 7px; border-radius: 50%; background: #f59e0b; display: inline-block; animation: irs-pulse 2s infinite; }
  @keyframes irs-pulse { 0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(245,158,11,0.5);}50%{opacity:.85;box-shadow:0 0 0 6px rgba(245,158,11,0);} }
  .irs-hero h1 { font-size: clamp(1.8rem, 3.75vw, 3rem); font-weight: 900; line-height: 1.1; letter-spacing: -0.03em; color: #0f172a; margin-bottom: 24px; }
  .irs-gradient-text { background: linear-gradient(135deg, #d97706, #ef4444); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .irs-hero p { font-size: 1.15rem; color: #475569; line-height: 1.75; margin-bottom: 40px; font-weight: 300; max-width: 520px; }
  .irs-btn-group { display: flex; gap: 14px; flex-wrap: wrap; }
  .irs-btn-primary { padding: 14px 28px; background: #0f172a; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .irs-btn-primary:hover { background: #d97706; box-shadow: 0 8px 24px rgba(217,119,6,0.35); transform: translateY(-1px); }
  .irs-btn-urgent { padding: 14px 28px; background: #fef3c7; color: #92400e; border: 1.5px solid #fcd34d; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .irs-btn-urgent:hover { background: #fde68a; border-color: #f59e0b; }

  /* Hero Visual */
  .irs-hero-visual { background: #fff; border-radius: 28px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(217,119,6,0.07); }
  .irs-vis-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; padding-bottom: 18px; border-bottom: 1px solid #f1f5f9; }
  .irs-vis-title p:first-child { font-size: 11px; color: #94a3b8; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 3px; }
  .irs-vis-title p:last-child { font-size: 17px; font-weight: 800; color: #0f172a; }
  .irs-vis-icon { width: 46px; height: 46px; background: linear-gradient(135deg, #d97706, #f59e0b); border-radius: 13px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .irs-notice-item { display: flex; align-items: flex-start; gap: 12px; padding: 14px; border-radius: 12px; margin-bottom: 10px; border: 1px solid; }
  .irs-notice-item.critical { background: #fff7ed; border-color: #fed7aa; }
  .irs-notice-item.warning { background: #fefce8; border-color: #fef08a; }
  .irs-notice-item.resolved { background: #f0fdf4; border-color: #d1fae5; }
  .irs-notice-icon { font-size: 18px; flex-shrink: 0; margin-top: 1px; }
  .irs-notice-label { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 3px; }
  .irs-notice-label.critical { color: #b45309; }
  .irs-notice-label.warning { color: #a16207; }
  .irs-notice-label.resolved { color: #059669; }
  .irs-notice-title { font-size: 13px; font-weight: 600; color: #334155; }
  .irs-notice-status { font-size: 11px; margin-top: 2px; }
  .irs-notice-status.critical { color: #d97706; }
  .irs-notice-status.warning { color: #ca8a04; }
  .irs-notice-status.resolved { color: #059669; }
  .irs-vis-footer { margin-top: 16px; padding: 14px 16px; background: #0f172a; border-radius: 12px; display: flex; align-items: center; gap: 10px; }
  .irs-vis-footer-dot { width: 8px; height: 8px; min-width: 8px; border-radius: 50%; background: #4ade80; box-shadow: 0 0 8px rgba(74,222,128,0.8); display: block; }
  .irs-vis-footer-text { font-size: 13px; color: #e2e8f0; font-weight: 500; }

  /* ─── Stats ─────────────────────────────────────────────────── */
  .irs-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .irs-stats-grid { display: grid; grid-template-columns: repeat(4,1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .irs-stats-grid { grid-template-columns: repeat(2,1fr); } }
  .irs-stat { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .irs-stat:last-child { border-right: none; }
  @media (max-width: 768px) { .irs-stat:nth-child(2n){ border-right:none; } .irs-stat{ border-bottom:1px solid #f1f5f9; } }
  .irs-stat-num { font-size: 2.2rem; font-weight: 900; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; color: #d97706; }
  .irs-stat-num.dark { color: #0f172a; }
  .irs-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ─── Section Base ───────────────────────────────────────────── */
  .irs-section { padding: 96px 24px; }
  .irs-container { max-width: 1200px; margin: 0 auto; }
  .irs-section-header { text-align: center; max-width: 700px; margin: 0 auto 64px; }
  .irs-section-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .irs-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.75; }
  .irs-label { display: inline-block; font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #d97706; margin-bottom: 12px; }

  /* ─── Notice Types ───────────────────────────────────────────── */
  .irs-notices { background: #f8fafc; }
  .irs-notices-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; }
  @media (max-width: 900px) { .irs-notices-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 600px) { .irs-notices-grid { grid-template-columns: 1fr; } }
  .irs-notice-card { background: #fff; border-radius: 20px; border: 1px solid #e2e8f0; padding: 28px; transition: all 0.3s; position: relative; overflow: hidden; }
  .irs-notice-card::before { content:''; position:absolute; top:0; left:0; right:0; height:3px; transform:scaleX(0); transform-origin:left; transition:transform 0.3s; }
  .irs-notice-card.amber::before { background: linear-gradient(90deg,#f59e0b,#ef4444); }
  .irs-notice-card.red::before { background: linear-gradient(90deg,#ef4444,#dc2626); }
  .irs-notice-card.blue::before { background: linear-gradient(90deg,#3b82f6,#6366f1); }
  .irs-notice-card:hover::before { transform:scaleX(1); }
  .irs-notice-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); border-color: #fcd34d; }
  .irs-nc-top { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px; }
  .irs-nc-icon { font-size: 28px; }
  .irs-nc-severity { font-size: 11px; font-weight: 700; padding: 3px 10px; border-radius: 999px; }
  .irs-nc-severity.high { background: #fff7ed; color: #b45309; }
  .irs-nc-severity.medium { background: #fefce8; color: #a16207; }
  .irs-nc-severity.low { background: #f0fdf4; color: #059669; }
  .irs-notice-card h3 { font-size: 1.05rem; font-weight: 700; color: #1e293b; margin-bottom: 8px; }
  .irs-notice-card p { font-size: 0.9rem; color: #64748b; line-height: 1.7; }

  /* ─── Process ───────────────────────────────────────────────── */
  .irs-process { background: #fff; }
  .irs-process-inner { background: #0f172a; border-radius: 32px; padding: 80px 64px; position: relative; overflow: hidden; }
  @media (max-width: 900px) { .irs-process-inner { padding: 48px 32px; } }
  .irs-proc-glow1 { position: absolute; top: 0; right: 0; width: 400px; height: 400px; background: radial-gradient(circle, rgba(245,158,11,0.2), transparent 70%); pointer-events: none; }
  .irs-proc-glow2 { position: absolute; bottom: 0; left: 0; width: 350px; height: 350px; background: radial-gradient(circle, rgba(239,68,68,0.12), transparent 70%); pointer-events: none; }
  .irs-proc-header { text-align: center; margin-bottom: 64px; position: relative; z-index: 1; }
  .irs-proc-header .irs-label { color: #fcd34d; }
  .irs-proc-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #fff; letter-spacing: -0.02em; }
  .irs-proc-header p { font-size: 1.05rem; color: #94a3b8; margin-top: 16px; line-height: 1.7; }
  .irs-steps { display: grid; grid-template-columns: repeat(4,1fr); gap: 28px; position: relative; z-index: 1; }
  @media (max-width: 900px) { .irs-steps { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 500px) { .irs-steps { grid-template-columns: 1fr; } }
  .irs-step { }
  .irs-step-num { width: 44px; height: 44px; border-radius: 12px; background: rgba(245,158,11,0.15); border: 1px solid rgba(245,158,11,0.3); display: flex; align-items: center; justify-content: center; font-size: 16px; font-weight: 800; color: #fcd34d; margin-bottom: 20px; }
  .irs-step h3 { font-size: 1.05rem; font-weight: 700; color: #f1f5f9; margin-bottom: 10px; }
  .irs-step p { font-size: 0.88rem; color: #94a3b8; line-height: 1.7; }

  /* ─── What We Handle ─────────────────────────────────────────── */
  .irs-handle { background: #f8fafc; }
  .irs-handle-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 20px; }
  @media (max-width: 768px) { .irs-handle-grid { grid-template-columns: 1fr; } }
  .irs-handle-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 20px; padding: 28px 32px; display: flex; gap: 20px; align-items: flex-start; transition: all 0.3s; }
  .irs-handle-card:hover { border-color: #fcd34d; box-shadow: 0 12px 40px rgba(0,0,0,0.07); transform: translateY(-2px); }
  .irs-handle-emoji { font-size: 28px; flex-shrink: 0; margin-top: 2px; }
  .irs-handle-card h3 { font-size: 1.05rem; font-weight: 700; color: #1e293b; margin-bottom: 8px; }
  .irs-handle-card p { font-size: 0.9rem; color: #64748b; line-height: 1.65; margin-bottom: 12px; }
  .irs-handle-tags { display: flex; flex-wrap: wrap; gap: 6px; }
  .irs-handle-tag { padding: 3px 10px; border-radius: 999px; font-size: 11px; font-weight: 600; background: #f1f5f9; color: #475569; }
  .irs-handle-card:hover .irs-handle-tag { background: #fef3c7; color: #92400e; }

  /* ─── Don't Go Alone ─────────────────────────────────────────── */
  .irs-alone { background: #fff; }
  .irs-alone-inner { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  @media (max-width: 900px) { .irs-alone-inner { grid-template-columns: 1fr; gap: 48px; } }
  .irs-alone-left h2 { font-size: clamp(1.8rem, 3.5vw, 2.6rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .irs-alone-left > p { font-size: 1.05rem; color: #64748b; line-height: 1.75; margin-bottom: 36px; }
  .irs-compare { display: flex; flex-direction: column; gap: 14px; }
  .irs-compare-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  .irs-compare-label { font-size: 12px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 10px; text-align: center; }
  .irs-compare-cell { padding: 12px 14px; border-radius: 10px; font-size: 13px; line-height: 1.5; }
  .irs-compare-cell.bad { background: #fff7ed; border: 1px solid #fde68a; color: #92400e; }
  .irs-compare-cell.good { background: #f0fdf4; border: 1px solid #d1fae5; color: #065f46; }
  .irs-alone-visual { background: #0f172a; border-radius: 24px; padding: 40px; position: relative; overflow: hidden; }
  .irs-alone-glow { position: absolute; top: 0; right: 0; width: 250px; height: 250px; background: radial-gradient(circle, rgba(245,158,11,0.2), transparent 70%); pointer-events: none; }
  .irs-outcome-label { font-size: 12px; color: #94a3b8; font-weight: 500; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 8px; }
  .irs-outcome-title { font-size: 1.6rem; font-weight: 900; color: #fff; margin-bottom: 28px; line-height: 1.2; }
  .irs-outcome-rows { display: flex; flex-direction: column; gap: 14px; }
  .irs-outcome-row { display: flex; gap: 12px; align-items: flex-start; }
  .irs-outcome-icon { font-size: 18px; flex-shrink: 0; margin-top: 1px; }
  .irs-outcome-text { font-size: 13px; color: #94a3b8; line-height: 1.55; }
  .irs-outcome-text strong { color: #fcd34d; font-weight: 700; }

  /* ─── FAQ ───────────────────────────────────────────────────── */
  .irs-faq { background: #f8fafc; }
  .irs-faq-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 18px; }
  @media (max-width: 768px) { .irs-faq-grid { grid-template-columns: 1fr; } }
  .irs-faq-item { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 26px; transition: all 0.2s; }
  .irs-faq-item:hover { border-color: #fcd34d; box-shadow: 0 4px 16px rgba(0,0,0,0.05); }
  .irs-faq-q { font-size: 0.98rem; font-weight: 700; color: #0f172a; margin-bottom: 10px; display: flex; gap: 10px; align-items: flex-start; }
  .irs-faq-q-icon { width: 22px; height: 22px; border-radius: 6px; background: #fef3c7; display: flex; align-items: center; justify-content: center; font-size: 12px; color: #d97706; flex-shrink: 0; margin-top: 1px; }
  .irs-faq-a { font-size: 0.9rem; color: #64748b; line-height: 1.7; }

  /* ─── CTA ────────────────────────────────────────────────────── */
  .irs-cta { background: #fff; border-top: 1px solid #f1f5f9; padding: 96px 24px; }
  .irs-cta-inner { background: #0f172a; border-radius: 32px; padding: 80px 48px; text-align: center; position: relative; overflow: hidden; max-width: 1000px; margin: 0 auto; }
  @media (max-width: 600px) { .irs-cta-inner { padding: 48px 24px; } }
  .irs-cta-glow1 { position: absolute; top: 0; right: 0; width: 360px; height: 360px; background: radial-gradient(circle, rgba(245,158,11,0.22), transparent 70%); pointer-events: none; }
  .irs-cta-glow2 { position: absolute; bottom: 0; left: 0; width: 300px; height: 300px; background: radial-gradient(circle, rgba(239,68,68,0.15), transparent 70%); pointer-events: none; }
  .irs-cta-inner h2 { font-size: clamp(2rem,4vw,3rem); font-weight: 900; color: #fff; letter-spacing: -0.03em; line-height: 1.15; margin-bottom: 20px; position: relative; z-index: 1; }
  .irs-cta-inner p { font-size: 1.1rem; color: #94a3b8; font-weight: 300; max-width: 540px; margin: 0 auto 40px; line-height: 1.75; position: relative; z-index: 1; }
  .irs-cta-btns { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; margin-bottom: 36px; }
  .irs-cta-primary { padding: 16px 32px; background: linear-gradient(135deg, #d97706, #f59e0b); color: #fff; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; box-shadow: 0 4px 20px rgba(217,119,6,0.4); }
  .irs-cta-primary:hover { transform: translateY(-1px); box-shadow: 0 8px 28px rgba(217,119,6,0.5); }
  .irs-cta-secondary { padding: 16px 32px; background: rgba(255,255,255,0.06); color: #fff; border: 1px solid rgba(255,255,255,0.15); border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .irs-cta-secondary:hover { background: rgba(255,255,255,0.1); }
  .irs-cta-badges { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; }
  .irs-cta-badge { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #94a3b8; }
  .irs-cta-badge-check { color: #fcd34d; }
`;

const fadeIn = { initial:{opacity:0,y:28}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-50px'}, transition:{duration:0.55} };
const stagger = (i:number) => ({ initial:{opacity:0,y:24}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-40px'}, transition:{duration:0.5,delay:i*0.1} });

const noticeTypes = [
  { cls:'amber', icon:'📬', severity:'High', severityClass:'high', title:'CP2000 — Underreported Income', desc:'The IRS believes income on your return doesn\'t match third-party data. Often leads to proposed additional tax plus penalties and interest.' },
  { cls:'red', icon:'⚠️', severity:'High', severityClass:'high', title:'CP90 / LT11 — Intent to Levy', desc:'A final notice before the IRS seizes wages, bank accounts, or property. Requires immediate action to prevent collection activity.' },
  { cls:'amber', icon:'🔍', severity:'Medium', severityClass:'medium', title:'CP75 — Audit / Examination', desc:'The IRS is examining your return for specific items such as business deductions, credits, or filing status. A response is required within 30 days.' },
  { cls:'blue', icon:'📋', severity:'Medium', severityClass:'medium', title:'CP504 — Balance Due Notice', desc:'You have an unpaid balance and the IRS has begun the collection process. Acting quickly can stop escalation to levies or tax liens.' },
  { cls:'amber', icon:'🏛️', severity:'Low', severityClass:'low', title:'Tax Lien — Form 668(Y)', desc:'The IRS has filed a public lien against your property. This affects credit and the ability to sell assets until the lien is released or subordinated.' },
  { cls:'blue', icon:'📊', severity:'Low', severityClass:'low', title:'Installment Agreement Review', desc:'The IRS is reviewing your existing payment plan. We negotiate favorable terms, hardship deferrals, and currently-not-collectible status.' },
];

const steps = [
  { num:'01', title:'Call Us First', desc:'Contact us immediately upon receiving any IRS notice. Time limits are strict — some are as short as 30 days. We begin reviewing your situation on the same day.' },
  { num:'02', title:'Power of Attorney', desc:'We file Form 2848 to become your authorized representative. From this point, the IRS communicates with us — not you. We handle everything.' },
  { num:'03', title:'Response & Negotiation', desc:'We prepare a comprehensive, documented response tailored to your notice type. We negotiate directly with IRS agents and appeals officers on your behalf.' },
  { num:'04', title:'Resolution & Protection', desc:'We secure the best possible outcome — penalty abatement, installment plans, offers in compromise, or full dismissal — and protect you going forward.' },
];

const handled = [
  { emoji:'🔍', title:'IRS Audits & Examinations', desc:'Correspondence audits, office audits, and field examinations. We handle all communication, documentation, and negotiation.', tags:['CP75','Exam Letters','Field Audits'] },
  { emoji:'💸', title:'Penalty Abatement', desc:'First-time penalty abatement (FTA) and reasonable cause arguments to eliminate or reduce failure-to-file, failure-to-pay, and accuracy penalties.', tags:['FTA','Reasonable Cause','Interest Reduction'] },
  { emoji:'🤝', title:'Installment Agreements', desc:'Negotiating structured payment plans that work with your cash flow — including partial pay agreements and hardship deferrals.', tags:['PPIA','Streamlined IA','Hardship Deferral'] },
  { emoji:'📉', title:'Offer in Compromise', desc:'When you genuinely cannot pay the full balance, we evaluate and prepare OIC submissions to settle your liability for less than owed.', tags:['OIC','Doubt as to Liability','Doubt as to Collectibility'] },
  { emoji:'🔒', title:'Tax Lien Management', desc:'Lien discharge, subordination, and withdrawal strategies to protect your credit, ability to finance, and property transactions.', tags:['Discharge','Subordination','Withdrawal'] },
  { emoji:'⛔', title:'Levy & Seizure Release', desc:'Emergency representation to release wage garnishments, bank levies, and asset seizures before they cause irreversible financial damage.', tags:['Wage Levy','Bank Levy','Asset Seizure'] },
];

const compareRows = [
  { bad:'Respond without professional review — admit to items you don\'t owe', good:'We review every line and only respond to what is legally required' },
  { bad:'Miss the deadline and lose all appeal rights permanently', good:'We track every deadline and file responses on time, every time' },
  { bad:'Provide too much information, triggering expanded examination scope', good:'Precise, targeted responses that don\'t open new issues' },
  { bad:'Accept proposed tax, penalties & interest as final', good:'We challenge proposed amounts and negotiate reductions aggressively' },
];

const faqs = [
  { q:'I just received an IRS letter. What should I do first?', a:'Do not ignore it and do not respond without professional help. Call us immediately. We\'ll identify the notice type, assess the deadline, and advise on the appropriate response — often within the same business day.' },
  { q:'Can you represent me in a full IRS audit?', a:'Yes. We represent clients in all types of IRS examinations — correspondence audits by mail, office audits, and full field audits conducted by revenue agents. We handle all communication on your behalf.' },
  { q:'What is an Offer in Compromise and do I qualify?', a:'An OIC allows you to settle your tax debt for less than the full amount owed when paying in full would cause genuine financial hardship. Qualification depends on income, assets, expenses, and future earning capacity. We evaluate this in your free consultation.' },
  { q:'Can you stop a wage garnishment or bank levy?', a:'In most cases, yes — if we act quickly. We file emergency representation and contact the IRS Collection Division directly to negotiate a release while we formalize a resolution. Time is critical in these situations.' },
  { q:'How long does IRS resolution typically take?', a:'Correspondence audit responses: 4–8 weeks. Installment agreements: 30–60 days. Offers in compromise: 12–24 months. Appeals: 6–18 months. We set realistic timelines and keep you informed throughout.' },
  { q:'What if I haven\'t filed returns for multiple years?', a:'Non-filer situations are common and highly solvable. We prepare all unfiled returns, negotiate a manageable resolution with the IRS, and get you back into compliance without the fear of criminal prosecution that inaction can trigger.' },
];

const IRSRepresentation: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <div className="irs-page">
    <style>{styles}</style>

    {/* Hero */}
    <section className="irs-hero">
      <div className="irs-hero-blob1" /><div className="irs-hero-blob2" />
      <div className="irs-hero-inner">
        <div>
          {onBack && (
            <button type="button" className="irs-back-btn" onClick={onBack}>
              <span aria-hidden="true">←</span> Back to Tax Services
            </button>
          )}
          <motion.div initial={{opacity:0,scale:0.9}} animate={{opacity:1,scale:1}} transition={{duration:0.5}}>
            <div className="irs-hero-badge"><span className="irs-badge-dot" />IRS notice? We respond for you — same day</div>
          </motion.div>
          <motion.h1 initial={{opacity:0,y:30}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.1}}>
            Got an IRS Letter?<br /><span className="irs-gradient-text">Don't Face It Alone.</span>
          </motion.h1>
          <motion.p initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.2}}>
            An IRS notice is not a conviction — but how you respond in the next 30 days can make or break the outcome. Our licensed CPAs become your authorized representative and handle everything so you don't have to say a word.
          </motion.p>
          <motion.div className="irs-btn-group" initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.5,delay:0.3}}>
            <button type="button" className="irs-btn-primary">Get Immediate Help →</button>
            <button type="button" className="irs-btn-urgent">⚡ Same-Day Response</button>
          </motion.div>
        </div>
        <motion.div className="irs-hero-visual" initial={{opacity:0,x:40}} animate={{opacity:1,x:0}} transition={{duration:0.7,delay:0.2}}>
          <div className="irs-vis-header">
            <div className="irs-vis-title"><p>Active IRS Cases</p><p>Client Dashboard</p></div>
            <div className="irs-vis-icon">🛡️</div>
          </div>
          {[
            {type:'critical',icon:'⚠️',label:'Critical',title:'CP90 — Intent to Levy (Bank Account)',status:'Response filed — levy suspended'},
            {type:'warning',icon:'🔍',label:'In Review',title:'CP2000 — Unreported Income Claim',status:'Documentation submitted, awaiting IRS'},
            {type:'resolved',icon:'✅',label:'Resolved',title:'CP504 — $18,400 Balance Due Notice',status:'Penalty abatement granted — $4,200 saved'},
          ].map((item,i) => (
            <div className={`irs-notice-item ${item.type}`} key={i}>
              <span className="irs-notice-icon">{item.icon}</span>
              <div>
                <div className={`irs-notice-label ${item.type}`}>{item.label}</div>
                <div className="irs-notice-title">{item.title}</div>
                <div className={`irs-notice-status ${item.type}`}>{item.status}</div>
              </div>
            </div>
          ))}
          <div className="irs-vis-footer">
            <span className="irs-vis-footer-dot" />
            <span className="irs-vis-footer-text">Your CPA is representing you — you don't speak to the IRS</span>
          </div>
        </motion.div>
      </div>
    </section>

    {/* Stats */}
    <div className="irs-stats">
      <div className="irs-stats-grid">
        {[
          {num:'98%',label:'Successful Resolution Rate',dark:false},
          {num:'$2.1M+',label:'Penalties & Interest Abated',dark:false},
          {num:'Same Day',label:'Response on Urgent Cases',dark:true},
          {num:'Licensed',label:'CPAs & Enrolled Agents Only',dark:true},
        ].map((s,i) => (
          <motion.div className="irs-stat" key={i} {...stagger(i)}>
            <div className={`irs-stat-num${s.dark?' dark':''}`}>{s.num}</div>
            <div className="irs-stat-label">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </div>

    {/* Notice Types */}
    <section className="irs-section irs-notices">
      <div className="irs-container">
        <motion.div className="irs-section-header" {...fadeIn}>
          <span className="irs-label">IRS Notices We Handle</span>
          <h2>Every Type of IRS Problem Has a Solution</h2>
          <p>We handle the full spectrum of IRS correspondence, audits, and collection actions — from a simple letter to a full levy release.</p>
        </motion.div>
        <div className="irs-notices-grid">
          {noticeTypes.map((n,i) => (
            <motion.div className={`irs-notice-card ${n.cls}`} key={i} {...stagger(i)}>
              <div className="irs-nc-top">
                <span className="irs-nc-icon">{n.icon}</span>
                <span className={`irs-nc-severity ${n.severityClass}`}>{n.severity} Priority</span>
              </div>
              <h3>{n.title}</h3>
              <p>{n.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* Process */}
    <section className="irs-section irs-process">
      <div className="irs-container">
        <div className="irs-process-inner">
          <div className="irs-proc-glow1" /><div className="irs-proc-glow2" />
          <motion.div className="irs-proc-header" {...fadeIn}>
            <span className="irs-label">Our Process</span>
            <h2>From Notice to Resolution in 4 Clear Steps</h2>
            <p>We move fast, communicate clearly, and keep you protected at every stage of the representation process.</p>
          </motion.div>
          <div className="irs-steps">
            {steps.map((s,i) => (
              <motion.div className="irs-step" key={i} {...stagger(i)}>
                <div className="irs-step-num">{s.num}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* What We Handle */}
    <section className="irs-section irs-handle">
      <div className="irs-container">
        <motion.div className="irs-section-header" {...fadeIn}>
          <span className="irs-label">Full Scope of Representation</span>
          <h2>No IRS Problem Is Too Complex</h2>
          <p>From a minor underreporting notice to a full audit or levy, we have the experience and authority to represent you at every level.</p>
        </motion.div>
        <div className="irs-handle-grid">
          {handled.map((h,i) => (
            <motion.div className="irs-handle-card" key={i} {...stagger(i)}>
              <span className="irs-handle-emoji">{h.emoji}</span>
              <div>
                <h3>{h.title}</h3>
                <p>{h.desc}</p>
                <div className="irs-handle-tags">{h.tags.map((t,j) => <span className="irs-handle-tag" key={j}>{t}</span>)}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* Don't Go Alone */}
    <section className="irs-section irs-alone">
      <div className="irs-container">
        <div className="irs-alone-inner">
          <motion.div className="irs-alone-left" {...fadeIn}>
            <span className="irs-label">Why Professional Representation Matters</span>
            <h2>The IRS Counts on You Not Knowing Your Rights</h2>
            <p>Most taxpayers respond to IRS notices without understanding what they're agreeing to — or what rights they're waiving. Professional representation changes that equation entirely.</p>
            <div className="irs-compare">
              <div className="irs-compare-row">
                <div className="irs-compare-label">Going It Alone</div>
                <div className="irs-compare-label">With BizServe</div>
              </div>
              {compareRows.map((row,i) => (
                <div className="irs-compare-row" key={i}>
                  <div className="irs-compare-cell bad">❌ {row.bad}</div>
                  <div className="irs-compare-cell good">✓ {row.good}</div>
                </div>
              ))}
            </div>
          </motion.div>
          <motion.div className="irs-alone-visual" initial={{opacity:0,x:30}} whileInView={{opacity:1,x:0}} viewport={{once:true}} transition={{duration:0.6,delay:0.2}}>
            <div className="irs-alone-glow" />
            <div className="irs-outcome-label">What Our Clients Avoid</div>
            <div className="irs-outcome-title">Outcomes We've Prevented</div>
            <div className="irs-outcome-rows">
              {[
                {icon:'🏦',text:'<strong>Bank account freezes</strong> that drain operating cash overnight with no warning'},
                {icon:'💼',text:'<strong>Wage garnishments</strong> that embarrass employees and disrupt payroll'},
                {icon:'🏠',text:'<strong>Federal tax liens</strong> that appear on credit reports and block property sales'},
                {icon:'📋',text:'<strong>Scope expansion</strong> from a narrow audit into a full multi-year examination'},
                {icon:'💸',text:'<strong>Paying full penalties</strong> when first-time abatement or reasonable cause would eliminate them'},
                {icon:'⏳',text:'<strong>Missing appeal deadlines</strong> that permanently waive your right to contest IRS findings'},
              ].map((item,i) => (
                <div className="irs-outcome-row" key={i}>
                  <span className="irs-outcome-icon">{item.icon}</span>
                  <div className="irs-outcome-text" dangerouslySetInnerHTML={{__html:item.text}} />
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>

    {/* FAQ */}
    <section className="irs-section irs-faq">
      <div className="irs-container">
        <motion.div className="irs-section-header" {...fadeIn}>
          <span className="irs-label">Common Questions</span>
          <h2>Everything You Need to Know About IRS Representation</h2>
          <p>If your situation isn't covered here, call us directly — we provide same-day consultations for urgent IRS matters.</p>
        </motion.div>
        <div className="irs-faq-grid">
          {faqs.map((f,i) => (
            <motion.div className="irs-faq-item" key={i} {...stagger(i)}>
              <div className="irs-faq-q"><div className="irs-faq-q-icon">?</div>{f.q}</div>
              <div className="irs-faq-a">{f.a}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="irs-cta">
      <div className="irs-cta-inner">
        <div className="irs-cta-glow1" /><div className="irs-cta-glow2" />
        <motion.h2 {...fadeIn}>Don't Wait. Deadlines Are Real.</motion.h2>
        <motion.p {...{...fadeIn,transition:{duration:0.55,delay:0.1}}}>
          IRS notices have hard deadlines that can permanently eliminate your rights to appeal. Contact us today — we respond urgently and protect you from the moment we're engaged.
        </motion.p>
        <motion.div className="irs-cta-btns" {...{...fadeIn,transition:{duration:0.5,delay:0.2}}}>
          <button type="button" className="irs-cta-primary">Get Immediate Help →</button>
          <button type="button" className="irs-cta-secondary">Free Case Review</button>
        </motion.div>
        <motion.div className="irs-cta-badges" {...{...fadeIn,transition:{duration:0.5,delay:0.3}}}>
          {['Same-day response available','Licensed CPAs & EAs','All notice types handled','Confidential consultation'].map((b,i) => (
            <div className="irs-cta-badge" key={i}><span className="irs-cta-badge-check">✓</span>{b}</div>
          ))}
        </motion.div>
      </div>
    </section>
  </div>
);

export default IRSRepresentation;
